import {MutationColumn} from './mutationcolumn';

export class MutationArrangement {

  constructor(geneWedges, currentMutations) {
    this.currentMutations = currentMutations;
    this.shownGenes = geneWedges.filter(gw=>gw.shown).map(gw=>gw.name);
    /* placeholder functions */
    this.labelFnc = mutation=>mutation.name;
    this.idFnc = mutation=>mutation.name;
  }

  /*
  sets something like:
    {
      geneName: {
        mutations: [mutation item],
        labels: {
          position (e.g. `614`) : {
            text,
            items : [mutation item]
          }
        }
      }
    }
  */
  arrange() {
    let {currentMutations, shownGenes} = this,
      genes = {};
    currentMutations?.forEach(item=>{
      let mutation = item.mutation,
        geneName = mutation.gene;
      if (shownGenes.indexOf(geneName) >= 0) {
        let geneData = genes[geneName],
          identifier = this.idFnc(mutation);
        if (!geneData) {
          geneData = {
            mutations: [],
            labels: {}
          };
          genes[geneName] = geneData;
        }
        if (!geneData.labels[identifier]) {
          let label = this.labelFnc(mutation);
          geneData.labels[identifier] = new MutationColumn(label);
        }
        geneData.labels[identifier].addItem(item);
        geneData.mutations.push(item);
      }

    });
    this.genes = genes;
    /* this can be different from currentMutations, which is always distinguished by name */
    this.labelList = Object.values(genes).reduce((muts, {labels})=>muts.concat(Object.values(labels)), []);
  }



  arrangeByName() {
    this.labelFnc = mutation=>mutation.label;
    this.idFnc = mutation=>mutation.label;
    this.arrange();
  }

  arrangeByPosition() {
    this.labelFnc = mutation=>mutation.posLabel;
    this.idFnc = mutation=>mutation.position;
    this.arrange();
  }


}